export default __webpack_public_path__ + "static/media/Summary.f00ce1b8.svg";